import { render, staticRenderFns } from "./clientLogoOne.svg.vue?vue&type=template&id=3a71e18a&"
import script from "./clientLogoOne.svg.vue?vue&type=script&lang=js&"
export * from "./clientLogoOne.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports